import { TextareaAutosize } from '@mui/material'
import React from 'react'
import { StyledSubHeader } from './Styled'
import { handleValidateCodevalue } from '../Utility/constant'
import { useSelector } from 'react-redux'

export const EntityNote = ({entityDetails , onChange , headingLabel ,isViewMode,name}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const fieldName = name || 'note';
  return (<>
    <StyledSubHeader>
                    {headingLabel}
    </StyledSubHeader>
        <TextareaAutosize
        disabled={isViewMode}
value={handleValidateCodevalue(internationalise, entityDetails?.[fieldName])}      
id={fieldName}
name={fieldName}        
minRows={2}
        maxRows={7}
         variant='standard'
                                   
        // placeholder="Enter your note here"
        style={{
    width: '100%',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '1rem',
    padding: '8px 10px',
    // border: '1px solid #656565',
    borderRadius: 12,
    resize: 'none',
    height: "50px",
    outline: 'none',
    transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  }}
  // onFocus={(e) =>
    
  //   (e.target.style.border = '1px solid 656565')
  // }
  // onBlur={(e) =>
  //   (e.target.style.border = '1px solid #656565)')
  // }
        onChange={onChange}
/>
</>
  )
}
